import { render, staticRenderFns } from "./ClientCompanyCountEditor.vue?vue&type=template&id=bb950072"
import script from "./ClientCompanyCountEditor.vue?vue&type=script&lang=js"
export * from "./ClientCompanyCountEditor.vue?vue&type=script&lang=js"
import style0 from "./ClientCompanyCountEditor.vue?vue&type=style&index=0&id=bb950072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports